import { takeEvery, call, put, all, fork, spawn } from 'redux-saga/effects';

import { userActions } from './actions';
import { userService } from '../../services/user';

import { onError } from '../../utils/onError';
import { openNotification } from '../../utils/openNotification';

import { history } from '../../settings/history';
import { notificationType } from '../../constants/notification';

function* loadUserListWatcher() {
  yield takeEvery(userActions.LOAD_USER_LIST, function* () {
    try {
      const response = yield call(userService.loadUserList);
      yield put(userActions.loadUserListSuccess(response));
    } catch (e) {
      yield put(userActions.loadUserListFail(e));
      yield spawn(onError, e);
    }
  });
}

function* loadUserBasicListWatcher() {
  yield takeEvery(userActions.LOAD_USER_BASIC_LIST, function* () {
    try {
      const response = yield call(userService.loadUserBasicList);
      yield put(userActions.loadUserBasicListSuccess(response));
    } catch (e) {
      yield put(userActions.loadUserBasicListFail(e));
      yield spawn(onError, e);
    }
  });
}

function* loadUserWatcher() {
  yield takeEvery(userActions.LOAD_USER, function* ({ payload }) {
    const { userId } = payload;
    try {
      const response = yield call(userService.loadUser, userId);
      yield put(userActions.loadUserSuccess(response.data));
    } catch (e) {
      yield put(userActions.loadUserFail(e));
      yield spawn(onError, e);
    }
  });
}

function* updateUserWatcher() {
  yield takeEvery(userActions.UPDATE_USER, function* ({ payload }) {
    const { userId, user } = payload;
    try {
      const response = yield call(userService.updateUser, userId, user);
      yield put(userActions.updateUserSuccess(response));
      yield spawn(openNotification, notificationType.success, 'global.editRecordSuccess');
    } catch (e) {
      yield put(userActions.updateUserFail(e));
      yield spawn(onError, e);
    }
  });
}

function* backToUserListWatcher() {
  yield takeEvery([userActions.LOAD_USER_FAIL, userActions.UPDATE_USER_SUCCESS], function* () {
    yield call(history.push, '/users');
  });
}

export function* userSaga() {
  yield all([
    fork(loadUserListWatcher),
    fork(loadUserBasicListWatcher),
    fork(loadUserWatcher),
    fork(updateUserWatcher),
    fork(backToUserListWatcher),
  ]);
}
